export const questions = [
    {
        id: 1,
        question: 'What is an AI Health Assistant?',
        answer: 'It is something.....'
    },
    {
        id: 2,
        question: 'How do I interact with the AI Health Assistant?',
        answer: 'To interact with the Docus AI Health Assistant, simply type in your questions or concerns in the designated AI chatbot, and the assistant will provide a response based on the information you provide.'
    },
    {
        id: 3,
        question: 'How accurate is the information provided by the AI Health Assistant?',
        answer: 'To interact with the Docus AI Health Assistant, simply type in your questions or concerns in the designated AI chatbot, and the assistant will provide a response based on the information you provide.'
    },
    {
        id: 4,
        question: 'Is the AI Health Assistant a replacement for a doctor?',
        answer: 'It is something.....'
    },

]
